import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

import useOrders from "./useOrders";
import useCart from "../cart/useCart";
import { useAuth } from "../../../utils/AuthContext";
import useCoupon from "../../adminDashboard/Coupons/useCoupon";
import useAddress from "../address/useAddress";
import CheckoutModal from "./CheckoutModal";
import OrderSuccessModal from "./OrderSuccessModal";
import useFetchProduct from "../../adminDashboard/products/useFetchProduct";

// import useCart from "../cart/useCart";
// import { useAuth } from "../../utils/AuthContext";

// import { Link } from "react-router-dom";
// import useAddress from "../userDashboard/address/useAddress";
// import useCoupon from "../Coupons/useCoupon";
// import useShipping from "../adminDashboard/shipping/useShipping";
// import OrderSuccessModal from "./OrderSuccessModal";

function CreateOrder({ setOrderSuccess, setOrderId }) {
  const { createOrderFn, isCreatingOrder } = useOrders();
  const { getOneProductFn } = useFetchProduct();
  const { cartItems, clearCartFn } = useCart();
  const { isLoggedIn, user } = useAuth();
  const [isModal, setIsModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponError, setCouponError] = useState("");
  // const [appliedCoupon, setAppliedCoupon] = useState("");
  const { addresses, addAddress, isAddingAddress } = useAddress();
  // const { shippingData } = useShipping();
  const defaultAddress = addresses?.find(
    (address) => address.isDefault === true
  );

  const { applyCouponFn, isApplyingCoupon, appliedCoupon } = useCoupon();

  const handleCreateOrder = async (selectedAddressId) => {
    const selectedAddress =
      addresses?.find((addr) => (addr.id || addr._id) === selectedAddressId) ||
      defaultAddress;
    if (!selectedAddress) {
      toast.error("Please select or add a delivery address");
      return;
    }

    // resolve products with categories
    const productsWithCategories =
      // await Promise.all(
      cartItems?.items;

    //   ?.map(async (item) => {
    //     const product = await getOneProductFn(item.productId);
    //     return {
    //       ...item,
    //       category: product?.category || null,
    //     };
    //   }) || []
    // );
    const orderData = {
      amount: appliedCoupon
        ? appliedCoupon.cart.summary.finalTotal
        : cartItems?.summary?.finalTotal || 0,
      address: selectedAddress.id || selectedAddress._id,
      products: productsWithCategories,
    };
    createOrderFn(orderData, {
      onSuccess: (data) => {
        clearCartFn();
        setOrderId(data?.order?._id || data?._id);
        setOrderSuccess(true);
        setIsModal(false);
      },
    });
  };

  // console.log("cart items summary: ", cartItems.summary);
  // console.log("shipping data: ", shippingData);
  // console.log("default address: ", defaultAddress);

  // const selectedShipping = shippingData?.shippingOptions?.find(
  //   (item) =>
  //     item?.governorate.toLowerCase() === defaultAddress?.title.toLowerCase()
  // );

  // Calculate cart totals
  const subtotal = cartItems?.summary?.originalTotal || 0;
  const discount = cartItems?.summary?.discountTotal || 0;
  // const shipping = selectedShipping?.price || 0;
  const shipping = 0;
  const total = subtotal + shipping - discount || 0;
  // console.log("applied coupon from cp: ", appliedCoupon);
  if (!isLoggedIn) {
    return (
      <div className="cart-summary lg:w-96 bg-white p-6 rounded-lg shadow-lg h-fit">
        <h3 className="text-2xl font-semibold mb-6">Cart Summary</h3>
        <div className="space-y-4">
          <div className="flex justify-between">
            <span className="text-gray-600">Subtotal</span>
            <span className="font-semibold">{subtotal} EGP</span>
          </div>
          {discount > 0 && (
            <div className="flex justify-between">
              <span className="text-gray-600">Discount</span>
              <span className="font-semibold text-green-600">
                -{discount} EGP
              </span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-gray-600">Shipping</span>
            <span className="font-semibold">{shipping} EGP</span>
          </div>
          <div className="border-t pt-4">
            <div className="flex justify-between">
              <span className="text-lg font-semibold">Total</span>
              <span className="text-lg font-bold text-[#DA0E1A]">
                {total} EGP
              </span>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <Link
            to="/signin"
            className="w-full bg-[#DA0E1A] text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors block text-center"
          >
            Sign in to Checkout
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="cart-summary lg:w-96 bg-white p-6 rounded-lg shadow-lg h-fit">
        <h3 className="text-2xl font-semibold mb-6">Cart Summary</h3>

        <div className="space-y-4">
          <div className="flex justify-between">
            <span className="text-gray-600">Subtotal</span>
            <span className="font-semibold">{Math.floor(subtotal)} EGP</span>
          </div>

          {discount > 0 && (
            <div className="flex justify-between">
              <span className="text-gray-600">Discount</span>
              <span className="font-semibold text-green-600">
                -{discount} EGP
              </span>
            </div>
          )}

          <div className="flex justify-between">
            <span className="text-gray-600">Shipping</span>
            <span className="font-semibold">{shipping} EGP</span>
          </div>

          <div className="border-t pt-4">
            <div className="flex justify-between">
              <span className="text-lg font-semibold">Total</span>
              {appliedCoupon ? (
                <div className="flex flex-col">
                  <del className="text-lg  text-[#DA0E1A]">
                    {Math.ceil(total)} EGP
                  </del>
                  <span className="font-bold text-lg">
                    {appliedCoupon.cart.summary.finalTotal} EGP
                  </span>
                </div>
              ) : (
                <span className="text-lg font-bold text-[#DA0E1A]">
                  {Math.ceil(total)} EGP
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-4">
          <button
            onClick={() => setIsModal(true)}
            className="w-full bg-[#DA0E1A] text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isCreatingOrder ? (
              <div className="flex items-center justify-center">
                <span className="ml-2 text-center mx-auto block">
                  Processing...
                </span>
              </div>
            ) : (
              "Place Order"
            )}
          </button>

          <Link
            to="/"
            className="w-full bg-gray-200 text-gray-800 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-colors block text-center"
          >
            Continue Shopping
          </Link>
        </div>

        <div className="mt-4">
          <label className="block font-medium text-gray-700 mb-1">
            Coupon Code
          </label>
          <div className="flex space-x-2">
            <input
              type="text"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              placeholder="Enter coupon"
              className="flex-1 border border-gray-300 rounded px-4 py-2"
            />
            <button
              disabled={isApplyingCoupon}
              onClick={() => {
                if (couponCode.trim() === "") {
                  toast.error("please provide coupon");
                } else applyCouponFn(couponCode);
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
            >
              Apply
            </button>
          </div>
          {couponError && (
            <p className="text-red-500 text-sm mt-1">{couponError}</p>
          )}
          {/* {appliedCoupon && ( */}
          <p className="text-green-600 text-sm mt-1">
            {/* {/* Coupon "{appliedCoupon.code}" applied: -{appliedCoupon.discount}{" "} */}{" "}
          </p>
        </div>
        <CheckoutModal
          open={isModal}
          onClose={setIsModal}
          addresses={addresses}
          defaultAddressId={defaultAddress?.id || defaultAddress?._id}
          onCheckout={handleCreateOrder}
          addAddressFn={addAddress}
          isLoading={isCreatingOrder || isAddingAddress}
        />
      </div>
    </>
  );
}

export default CreateOrder;
